// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"ListingCardsCarouselSection_sectionHeading__166JU"};